/* eslint-disable max-len */
//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//
/** @public */
export var ContextTransformFieldValues = ('calendar-field currencyName day-format-except-narrow day-standalone-except-narrow era-abbr era-name keyValue languages month-format-except-narrow month-standalone-except-narrow number-spellout relative script typographicNames').split(' ');
//# sourceMappingURL=autogen.context.js.map